module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "imagel"
  }, [_c('img', {
    staticStyle: {
      "height": "70px"
    },
    attrs: {
      "alt": "image",
      "src": "images/pg12_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image1",
    staticStyle: {
      "height": "7px"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "chap-title1",
    attrs: {
      "id": "sec1"
    }
  }, [_c('b', [_vm._v("Week 1: Embrace Your"), _c('br'), _vm._v("Identity in God")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("“Before I formed you in the womb I knew you,"), _c('br'), _vm._v("before you were born I set you apart.”")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote1"
  }, [_vm._v("—Jeremiah 1:5")]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }, [_c('p', {
    staticClass: "noindents"
  }, [_vm._v("Recommended Reading:")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("The story of David and Goliath (1 Samuel 17)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("It’s tempting to define yourself by the views and likes on social media. But here’s some real talk: you’re worth so much more. Your identity is rooted in how God sees you, not how the world sees you. Like Jeremiah’s affirmation that God recognized and esteemed you even before birth, your true self is eternal and immutable. I hope you uncover layers of your identity and their deep ties to God this week.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("God crafted you with a specific vision. That’s the thrill—there’s nobody else in the world just like you! Embracing this realization is the secret to shaking off external pressures. In the Bible, you’ll often see that those who understood their divine identity stood out and made a difference. And the first steps? Dive deep into prayer and scripture, and build connections with other uplifting, faith-driven teens.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("David’s face-off with Goliath in First Samuel is an inspiring tale of self-worth. David, the youngest and often overlooked boy, knew his worth not from the world but from God. He internalized the very essence of Jeremiah’s words, recognizing that his true identity lay in his relationship with the Divine. When Goliath, the Philistine giant, taunted the Israelites, everyone hesitated except David. Despite King Saul’s reservations about his young age, David was unwavering. He recounted his victories over a lion and a bear, attributing them to God: “The Lord who rescued me from the paw of the lion and the paw of the bear will rescue me from the hand of this Philistine” (1 Samuel 17:34–37).")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("With just a sling and five stones, David confronted Goliath. And with a precise shot, he defeated Goliath. This victory wasn’t just David’s; it was a win for everyone who knew their worth in God’s eyes. It echoed the profound message of Jeremiah, proving that your divine identity is a source of unparalleled strength.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Your True Self")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Ever felt like the world’s trying to put you into a box? Between the rush for likes, the race for views, and the urge to trend on social media, it sometimes feels like you’re always chasing an elusive mold. Ever thought, “Is this truly me?” Your identity isn’t defined by trends or peers. It’s anchored in God, who designed you with precision and love, like a passionate artist. And once you truly grasp this? You’ll experience the exhilaration of authentic living.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Rising Above")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Nathalie had always been good at science. It was a simple fact, like how the sun rises or how fish swim. One day, the school picked her to lead a science project—a model for a green city. Important. Potentially national science fair material.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("But in the echo of the school’s empty corridors, she heard it. A whisper, sharp as the sting of a bee. “Why Nathalie? Sarah’s better for this,” they said. The words settled heavily in her chest.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("That evening, a glass of water in her hand, she caught her own eyes in the window’s reflection. Doubt stared back. Just then, a gust of wind blew an old card off her bedside table. It read, Psalm 139:14: “I praise you because I am fearfully and wonderfully made.” The passage echoed the message of Jeremiah, emphasizing that God’s design and purpose for us is unique and special. The words weren’t just comforting; they were empowering. She wasn’t just Nathalie, the student; she was Nathalie, the innovator, the problem solver. She considered the verse for a moment, then started sketching.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("With renewed vigor, she used her faith as a foundation for her actions. The following weeks were methodical. Nathalie made plans; she implemented changes. The prototype emerged—solar designs, recycled materials. The project became a testament to the beauty of simple, sustainable living. Nathalie displayed divine craftsmanship through her work, just as Jeremiah had declared.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The day came. The school gathered. Nathalie presented, each word measured, each fact irrefutable. With the prototype on display, Nathalie passionately explained its features and benefits. She discussed rainwater collection, solar panels, and green spaces designed for urban settings. The murmurs faded. The applause afterward felt like a roaring ocean. Even the whispering girls stood, looking at Nathalie’s project with newfound respect.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("But for Nathalie, it was never about the crowd. It was about the quiet resolve, the work, the understanding that she had a place in the world, and it was right where she stood. She faced doubt, leaned on her faith, and emerged stronger. Her journey mirrored David’s, showcasing that your connection with God is an unbreakable rope to your true self. Because, at the end of the day, it’s not about what others think, but how you rise above and find your rhythm.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Daily Dose of Faith")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Jeremiah reminds you of your unique creation even before your birth. Want to harness authenticity?")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/star.jpg"
    }
  })]), _c('b', [_vm._v("Dive into the Bible:")]), _vm._v(" Embrace scriptures that resonate with you and let them guide your days.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/star.jpg"
    }
  })]), _c('b', [_vm._v("Build Your Tribe:")]), _vm._v(" Seek friends who elevate your faith rather than drench you in negativity.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/star.jpg"
    }
  })]), _c('b', [_vm._v("Reflect:")]), _vm._v(" A journal (or even your phone’s notes app) can be a haven. Ponder on scriptures, and see their influence in your daily encounters. Pen down your emotions and see the magic.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Living the Faith")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Living in faith means understanding that you have a designated purpose meticulously crafted by the Creator. Own your identity in God! Remember David. He looked like an underdog, yet he defeated Goliath. Drawing strength from his deep-seated belief in his God-given worth, he knew his worth in God’s eyes, and with that belief, you, too, can face any challenge.")]), _vm._v(" "), _c('div', {
    staticClass: "black"
  }, [_c('p', {
    staticClass: "noindents1"
  }, [_c('b', [_vm._v("Journal Time!")])])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/star.jpg"
    }
  })]), _vm._v("Reflect on a moment when you felt out of place. How did you feel? Did you feel distanced from your divine identity? Knowing what you do now, what advice would you give your younger self?")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/star.jpg"
    }
  })]), _vm._v("What’s a quirky trait you possess? How can you view it as God’s special touch in creating you? Think about how this trait might mirror a specific purpose God has for you.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/star.jpg"
    }
  })]), _vm._v("What would it say if God sent you a direct message expressing how He sees you? Would it echo Jeremiah’s words, reminding you of your unique creation and purpose?")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Wrapping Up the Week")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("As you move through the week, never forget: you’re not just a face in a vast crowd. Crafted with divine precision, you are a unique masterpiece, born from the love and intentionality of the Creator, a testament to God’s unmatched artistry.")]), _vm._v(" "), _c('p', {
    staticClass: "imagel"
  }, [_c('img', {
    staticStyle: {
      "height": "70px"
    },
    attrs: {
      "alt": "image",
      "src": "images/pg10_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "imager"
  }, [_c('img', {
    staticStyle: {
      "height": "70px"
    },
    attrs: {
      "alt": "image",
      "src": "images/pg17_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image1",
    staticStyle: {
      "height": "7px"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "chap-title1",
    attrs: {
      "id": "sec2"
    }
  }, [_c('b', [_vm._v("Week 2: Build Self-Worth"), _c('br'), _vm._v("and Confidence")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("“I can do all things through Christ who strengthens me.”")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote1"
  }, [_vm._v("—Philippians 4:13")]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }, [_c('p', {
    staticClass: "noindents"
  }, [_vm._v("Recommended Reading:")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("The story of Deborah (Judges 4 and 5)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Everyone’s buzzing about “self-worth” and “confidence,” but the road to truly understanding these words is one epic journey. You live in a world that constantly tells you that you’re not enough. But guess what? God sees you differently. You can learn the divine truth about your worth and confidence. You can draw strength and confidence from Christ, reaffirming your self-worth in Him.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Scripture is filled with stories of women who exemplify empowerment and divine purpose. Their tales echo a timeless truth: that your self-worth is inherent, given by God. These tales teach you that no matter your background or society’s expectations, God’s plans and your self-worth are deeply intertwined.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Deborah, a prophetess, was the only female judge mentioned in the Bible. In a time dominated by male leaders, she stood out as a pillar of strength, wisdom, and inspiration. Israel was facing oppression from the Canaanite King Jabin. Under Deborah’s leadership and direction, Barak led the Israelites into battle. With her prophecy and encouragement, Barak and the Israelites achieved a stunning victory over their oppressors.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Deborah’s faith, coupled with her understanding of her divine role, led her people to freedom. Her story emphasizes that when you recognize your God-given worth and purpose, you can rise above societal constraints.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Your True Self")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Despite societal constraints, Deborah grasped her divine purpose, showcasing that her leadership was not just a position, but a reflection of her understanding of her worth in God’s grand plan. Through her, you can learn the power of confidence grounded in divine purpose. Even in a patriarchal society, Deborah’s confidence in her purpose shone as a light of hope.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Isn’t it a tad crazy that with billions of people in the world, there’s only one "), _c('i', [_vm._v("you")]), _vm._v("? This distinctiveness is God’s signature on your life. Getting caught up in the comparison game is easy—grades, sports, followers, or fashion. Flip the script. Instead of trying to fit into someone else’s shoes, recognize that your pair, designed by God Himself, fits perfectly. The spotlight shouldn’t be on what you lack, but on celebrating what you have.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Luminous Strokes")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("At Jericho High, Alex was the golden girl—the captain of the cheerleading squad and an honor roll student. Jenny, her sixteen-year-old sister, was mostly referred to as “Alex’s younger sister.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("But in the quiet of her room, surrounded by a world of color and sketches, Jenny came alive. The rustling pages and the swish of her brushes were her sanctuary. Here, she wasn’t in Alex’s shadow but in the embrace of her own luminous world. Just like Deborah found her strength in God, Jenny found hers in God’s gift: the strokes of her brush.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("One afternoon, after a particularly grueling math test, Jenny found a note in her sketchbook. It read: “See me after class.—Mrs. Harris.” The heartbeats in Jenny’s chest quickened. She couldn’t recall doing anything wrong in her art class.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("After school, she approached Mrs. Harris’s classroom with trepidation. The familiar smell of paint and turpentine greeted her. “Jenny,” Mrs. Harris began, “I hope you’re not mad, but I entered one of your sketches in the Statewide Youth Art Contest.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Jenny was taken aback. “You did what?”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Mrs. Harris handed her a brochure. On the cover was Jenny’s sketch: a delicate rendition of an old oak tree from the schoolyard. The light filtered through its leaves, casting dappled shadows. It was a moment Jenny had captured during a lonely lunch, feeling overshadowed by Alex’s achievements.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“A week ago,” Mrs. Harris continued, “I received the results.” She paused, letting the tension build, then grinned. “You won, Jenny. First place.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Jenny felt a rush of emotions—disbelief, gratitude, and an overwhelming sense of validation. Her hands trembled as she held the brochure. A small award ceremony was scheduled for the following week.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The day arrived faster than Jenny could process it. The school auditorium was abuzz with chatter, but for the first time, it wasn’t about Alex. It was about Jenny’s art.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("As she stepped on stage to receive her award, she spotted Alex in the crowd. Her sister was beaming with pride, her eyes shining bright. But what struck Jenny most was a newfound respect in Alex’s gaze. They were no longer just the popular girl and her overshadowed sister; they were two individuals, each with their own talent and worth. Through her journey, Jenny embraced the Philippians 4:13 truth: with Christ, she could achieve all things. She saw her potential through God’s lens; she realized her worth.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In the weeks that followed, Jenny’s sketches garnered more attention. Students approached her for custom pieces, and teachers applauded her talent. Jenny’s journey underscores the transformative power of self-worth and divine guidance. Her most significant change was internal. Jenny painted her story with each brush stroke, understanding that everyone has their spotlight, waiting for the right moment to shine.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("As Jenny added the award to her art corner, she took a moment to reflect. It wasn’t the accolade that mattered most; it was the realization that followed. She didn’t have to walk in Alex’s shadow or mimic her path. She had her own journey, one that was unique and divinely crafted.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Daily Dose of Faith")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Self-worth isn’t just a one-time achievement. As you learn from Deborah, it’s an ongoing journey of faith and understanding. It’s like a favorite song on repeat. Much like Deborah experienced, it’s the affirmation that God values and believes in you. Your actions, words, and thoughts align when you truly believe in your divine worth. You no longer hustle for approval; instead, you radiate confidence, not from vanity but from a deep-rooted belief in God’s love for you.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/star.jpg"
    }
  })]), _c('b', [_vm._v("Mirror Talk:")]), _vm._v(" Look in the mirror every morning and say something positive about yourself.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/star.jpg"
    }
  })]), _c('b', [_vm._v("Positive Vibes Only:")]), _vm._v(" Steer clear of negativity. Surround yourself with uplifting friends, music, and media.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/star.jpg"
    }
  })]), _c('b', [_vm._v("Skill Up:")]), _vm._v(" Is there something you’re passionate about? Dive in deeper! Whether it’s painting, writing, or coding, make time for it.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Living the Faith")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Stories like that of Deborah are timeless reminders of your potential and God’s plan in your life. Deborah’s confidence stemmed from her unwavering faith. By recognizing God’s hand in their stories, Deborah and Jenny could redefine their self-worth in a world of expectations. You can find confidence and purpose in your path by embracing your unique gifts and roles.")]), _vm._v(" "), _c('div', {
    staticClass: "black"
  }, [_c('p', {
    staticClass: "noindents1"
  }, [_c('b', [_vm._v("Journal Time!")])])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/star.jpg"
    }
  })]), _vm._v("Reflect on a time you felt overshadowed or underestimated. How did it feel, and how did you overcome it? Dive deep into that moment. Recall the emotions, surroundings, and internal dialogue. Then, think about how God might have been guiding you through that experience. Perhaps, like Deborah, He was preparing you for something bigger.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/star.jpg"
    }
  })]), _vm._v("Write about a talent or quality you have but tend to undervalue. You have gifts, some of which you might not recognize or appreciate fully. Describe one of these qualities or talents. What makes it unique? And how can you use it for a greater purpose? Connect this to how Deborah utilized her leadership skills at a time when women leaders were scarce.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/star.jpg"
    }
  })]), _vm._v("If God were to give you a pep talk right now, what would He say? Imagine sitting across from Him, listening intently. What words of encouragement, guidance, or love would He share with you? He sees your full potential, much like He saw Deborah’s. Allow this exercise to bring comfort, motivation, and a renewed sense of purpose.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Wrapping Up the Week")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("As you come to the end of this week, remember: your worth is not determined by society’s standards, peer opinions, or even self-imposed expectations. As beautifully illustrated in the story of Deborah, and even Jenny, your worth is divinely ordained. It is unchangeable, eternal, and deeply rooted in God’s love for you.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Every time you doubt your worth or feel overshadowed, envision a loving God cheering you on, whispering words of encouragement. Embrace the truth that “With God on our side, who can be against us?” (Romans 8:31). (“You got this because I got you!”) Hold onto that unwavering faith, let it be your guiding light, and march confidently into the days ahead. With your unique talents and story, you have a distinct place in God’s divine plan.")]), _vm._v(" "), _c('p', {
    staticClass: "imagel"
  }, [_c('img', {
    staticStyle: {
      "height": "70px"
    },
    attrs: {
      "alt": "image",
      "src": "images/pg10_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "imager"
  }, [_c('img', {
    staticStyle: {
      "height": "70px"
    },
    attrs: {
      "alt": "image",
      "src": "images/pg17_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image1",
    staticStyle: {
      "height": "7px"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "chap-title1",
    attrs: {
      "id": "sec3"
    }
  }, [_c('b', [_vm._v("Week 3: Navigate Friendships"), _c('br'), _vm._v("Gracefully")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("“Do not be misled: Bad company corrupts"), _c('br'), _vm._v("good character.”")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote1"
  }, [_vm._v("—1 Corinthians 15:33")]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }, [_c('p', {
    staticClass: "noindents"
  }, [_vm._v("Recommended Reading:")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("The story of Naomi and Ruth (Book of Ruth)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Friendships offer unexpected turns and lessons. They have ups and downs, doubt, joy, and resilience. Like the bond between Naomi and Ruth, friendships can teach us loyalty and steadfastness. And while friendships might seem like rollercoaster rides, they lay the foundation for bonds that could last a lifetime. Faith and understanding can help navigate these intricacies.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The steadfast bond between Naomi and Ruth in the Bible echoes the complexities and beauties of friendships. Naomi, an Israelite, and her family moved from Bethlehem to Moab due to a famine. In Moab, her two sons married Moabite women, one of whom was Ruth. Unfortunately, tragedy struck Naomi when she lost her husband and her two sons. Left in a foreign land with her two daughters-in-law, Naomi decided to return to Bethlehem. She urged her daughters-in-law to return to their families so that they could have a chance at a better life. Orpah, one of them, tearfully went back. But Ruth made a heart-moving declaration of loyalty: “Do not urge me to leave you or to return from following you. For where you go, I will go, and where you lodge, I will lodge. Your people shall be my people, and your God my God” (Ruth 1:16).")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("This unwavering commitment seen in Ruth’s words is the very essence that friendships should strive for in today’s world. Ruth’s commitment to Naomi wasn’t just out of duty as a daughter-in-law but out of genuine love and companionship. She left her homeland, people, and gods to stand by Naomi’s side.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Upon returning to Bethlehem, Ruth faced challenges as a foreigner. But her loyalty to Naomi and her hard work in the fields caught the attention of Boaz, a kind and wealthy landowner. Boaz and Ruth’s eventual marriage ensured the well-being of the widowed Naomi, illustrating how Ruth’s decision to stay with Naomi led to blessings for them both.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Their story showcases the selflessness, loyalty, and strength inherent in true friendships. The loyalty of Ruth serves as a timeless reminder for you today. Ruth’s devotion to Naomi goes beyond societal norms and expectations of that era, demonstrating that true friendships transcend cultural barriers, personal losses, and even life-altering decisions. The Book of Ruth in the Bible is a testament to the power of loyalty, love, and faith between two women.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Your True Self")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The pressure is everywhere—to fit in, be liked, and keep up with trends. Social media doesn’t help either, with constant comparisons and “friendship goals.” This can lead to feelings of inadequacy. Much like Ruth and Naomi sought authenticity in their relationship, it’s vital to seek genuine connections. Recognizing that friendships need to embrace this authentic self, instead of a version influenced by external pressures, can be liberating.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Just Patricia and Maria")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("High school began at Jericho. Patricia met Maria. On their first day, Patricia, with her quiet demeanor, and Maria, all smiles and words, sat side by side in English. Their unlikely friendship had traces of Naomi and Ruth’s bond, different yet connected at the core. It was odd, like oil and water. Yet, with its funny way of mixing things, the universe made them friends.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("They’d share sandwiches and secrets. Maria always talking, always moving. Patricia? She listened. She noticed everything—like how Maria’s laugh changed when certain people were around. Or how she started wearing brighter lipsticks as the year went by.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Maria became popular. Patricia saw it coming before Maria did. The school was big, but Maria’s name was everywhere. Maria’s popularity skyrocketed, and Patricia felt left behind. Lunches without Maria became frequent for Patricia. Whispers, glances—they all told Patricia one thing: Maria’s world was changing. And maybe, Patricia wasn’t in it.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Then, the project happened. The universe’s sense of humor, maybe. The teacher paired the two of them. Patricia felt the tension the first day they sat together, project papers between them. Patricia scribbled notes; Maria was distracted. Her phone kept buzzing. Each vibration took away a bit of Maria, Patricia thought.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("It was when the fourth call in an hour came, Maria snapped. She turned the phone face down, tears welling up. “Everyone wants a piece of me, but no one really knows me,” she whispered. Maria confided in Patricia, sharing her struggles with her newfound popularity and the constant need to fit in.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Patricia, taken aback, realized she wasn’t the only one feeling adrift. Here was Maria, the heart of every party, equally lost. Patricia didn’t say anything. She just passed a tissue. She understood, though. Watching Maria, she always understood more than Maria thought she did.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The room was silent for a long time. Just the hum of the air conditioner and Maria’s quiet sniffling. “Remember our first lunch?” Maria broke the silence. Patricia nodded. “I miss that. Just…us. No noise.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The project nights became their haven. They worked, sure. But more than that, they found their rhythm again. Laughs, quiet conversations, and sometimes just silence. They finished the project, but something more important was rebuilt: trust.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The school year ended. Maria, still in the limelight, but now with Patricia by her side. Not behind or ahead, but beside. People noticed, or maybe they didn’t. It didn’t matter to Patricia. Because in the noise of high school, in the chaos of growing up, Patricia and Maria had found their quiet corner. And that was enough.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Daily Dose of Faith")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/star.jpg"
    }
  })]), _vm._v("Start your day with a prayer, asking God to bless your friendships, to infuse them with understanding, patience, and love.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/star.jpg"
    }
  })]), _vm._v("Reflect on Proverbs 27:9, “Ointment and perfume rejoice the heart: so doth the sweetness of a man’s friend by hearty counsel.”")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Living the Faith")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Here’s another example to consider. Mei always prays before making decisions. Like Ruth seeking God’s guidance when choosing to stay with Naomi, when a rift occurs in her friend circle due to a misunderstanding, she prays for clarity and guidance instead of immediately taking sides. This helps her approach the situation calmly, allowing for a resolution grounded in understanding and forgiveness.")]), _vm._v(" "), _c('div', {
    staticClass: "black"
  }, [_c('p', {
    staticClass: "noindents1"
  }, [_c('b', [_vm._v("Journal Time!")])])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/star.jpg"
    }
  })]), _vm._v("Have you ever had someone who stood by you against all odds? Just as Ruth stood by Naomi, write about this experience.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/star.jpg"
    }
  })]), _vm._v("Are there moments you’ve felt pressured to change for a friend? Reflect on how it made you feel and how you can address it in the future.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/star.jpg"
    }
  })]), _vm._v("Think about your closest friendships. What values anchor these relationships?")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Wrapping Up the Week")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("As you journey through the challenges and joys of friendships, ground them in faith and lessons from the past, and let them be bonds that illuminate your path. These relationships play a vital role in shaping who you become. Grounding them in God’s teachings ensures they’re not just temporary bonds but lifetime connections. So, as you navigate the maze of friendships, let faith be your guiding star.")]), _vm._v(" "), _c('p', {
    staticClass: "imager"
  }, [_c('img', {
    staticStyle: {
      "height": "70px"
    },
    attrs: {
      "alt": "image",
      "src": "images/pg27_3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "imagel"
  }, [_c('img', {
    staticStyle: {
      "height": "70px"
    },
    attrs: {
      "alt": "image",
      "src": "images/pg28_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image1",
    staticStyle: {
      "height": "7px"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "chap-title1",
    attrs: {
      "id": "sec4"
    }
  }, [_c('b', [_vm._v("Week 4: Cultivate a"), _c('br'), _vm._v("Strong Prayer Life")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("“Do not be anxious about anything, but in every situation,"), _c('br'), _vm._v("by prayer and petition, with thanksgiving, present your"), _c('br'), _vm._v("requests to God. And the peace of God, which transcends"), _c('br'), _vm._v("all understanding, will guard your hearts and your minds"), _c('br'), _vm._v("in Christ Jesus.”")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote1"
  }, [_vm._v("—Philippians 4:6–7")]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }, [_c('p', {
    staticClass: "noindents"
  }, [_vm._v("Recommended Readings:")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("Psalms 42, 62, 143")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Alright! This week is about leveling up your relationship with God through prayer. Much like how Jesus consistently turned to prayer during his time on earth, think of it as sending a DM to the creator of the universe, where He’s always online and never leaves you on “read.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Dive into Jesus’s times. His life reminds you of prayer’s undeniable importance in facing life’s challenges. He was the busiest guy around—healing, teaching, dealing with drama. Yet, He took time to chill and pray. Luke 11 is kinda like Jesus giving you the ultimate DM template (a.k.a. the Lord’s Prayer). It covers praising God, asking for help, and seeking guidance. The Psalms are like ancient songs of the heart—raw, real, and relatable, showing you that it’s okay to be vulnerable with God.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Your True Self")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In moments of doubt or fear, remember that turning to prayer, as Jesus did, can provide solace. Life is a wild ride. Insta-perfect lives can make your real-life struggles feel isolating. But guess what? You’re not alone. God wants to hear every thought, fear, and emoji-heart-filled joy in your life. Through prayer, you can find authentic connections in a world of filters.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("In the Calm and the Chaos")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Michelle’s room was a refuge from chaos outside. But even in the most peaceful environments, life can test your faith, pushing you toward prayer. Michelle’s phone buzzed with a barrage of notifications—messages about the school project due next week, group chats filled with the latest friendship fallout, and one singular message from her mom: “Grandma’s taken a turn for the worse.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The walls seemed to inch closer. She felt overwhelmed, like she was standing at the edge of a precipice. And in that quiet, desperate moment, with tears threatening to spill, she whispered, “Help, God! I can’t do this.” The plea was raw, like a wounded animal calling out.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Michelle didn’t know she needed God—or what she expected now. But in the stillness that followed, she felt an inexplicable warmth.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Beginning that day, Michelle formed a habit. Before bed, she would sit by her window every night, looking out at the crescent moon, and talk to God. Sometimes it was a casual chat, other times, a fervent prayer. But every night, without fail, she reached out. She’d never been religious, never been one to pray. Yet, now, speaking to God felt like talking to an old friend—one who listened, without judgment, without any need for a response.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Sometimes, she doubted herself, wondering if she was just talking into the void. Like the day of her math exam, when anxiety gripped her, she whispered a quick prayer and felt a sudden surge of confidence. Or the night she learned her grandma had been moved to intensive care. Michelle sobbed, her voice hoarse, whispering her hopes and fears into the dark. She continued to pray. For Michelle, prayer was about comfort, the idea that someone out there was listening, providing strength when she felt she had none left.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("When friendship dramas erupted at school, Michelle learned to step back, take a deep breath, and send a silent prayer. It gave her perspective, the ability to navigate teenage turbulence with a grace she never knew she possessed.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Grandma’s illness was a long, drawn-out affair. Nights at the hospital, watching the frail figure in the bed, became a routine. Michelle’s whispered conversations with God continued through it all, her anchor in the stormy seas. The chaos of life didn’t dissipate. But in Michelle’s heart, a quiet strength had taken root. And with it, she realized she could face any storm that came her way.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("One evening, as she sat beside her grandma’s bed, her grandmother, now recovering, whispered, “You have strength in you, Michelle. I’ve seen it these past weeks. Remember to always lean on it.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Michelle smiled, squeezing her grandma’s hand. The strength her grandma spoke of wasn’t just her own; it was the culmination of every whispered prayer, every plea, every hope she had shared with God.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Daily Dose of Faith")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The same way Jesus made time to connect with God, you too can integrate prayer into your daily routine. Try the “Three-Times-Chime.” Set three alarms on your phone daily. One for morning, noon, and night. When it chimes, take a minute, just sixty seconds, to shoot a prayer upwards. Maybe it’s gratitude, a request, or a shoutout for a friend. Watch how this simple act transforms your day!")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Living the Faith")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Just as Jesus lived out the words he prayed, let your actions reflect your conversations with God. Ever heard the saying, “Walk it like you talk it”? Well, that’s how you should be with your faith. If you’re praying for patience and courage, look out for daily opportunities to put that into action. Maybe it’s taking a deep breath when you’re about to snap at a sibling, speaking up when you see someone being treated unfairly, showing kindness to a stranger, or standing up against bullying. Let your prayers guide your actions.")]), _vm._v(" "), _c('div', {
    staticClass: "black"
  }, [_c('p', {
    staticClass: "noindents1"
  }, [_c('b', [_vm._v("Journal Time!")])])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/star.jpg"
    }
  })]), _vm._v("Reflecting on Jesus’s prayer life can inspire your own. Pop quiz! How often do you pray? No judgment, just an honest check-in.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/star.jpg"
    }
  })]), _vm._v("Draft a tweet-length prayer. Short, impactful, and straight from the heart. Go!")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/star.jpg"
    }
  })]), _vm._v("Think about a friend who could use some love. How can you include them in your prayers this week?")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Wrapping Up the Week")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Jesus’s consistent communication with God is a guiding light for you. You can always pray in moments of joy, sorrow, doubt, or gratitude. It’s your bridge to unwavering love, guidance, and strength. Here’s the deal: life’s going to throw curveballs. Prayer isn’t about dodging them but finding the strength to hit them out of the park. You’ve got direct access to the ultimate source of power, comfort, and guidance. So, slide into God’s DMs and keep that conversation going!")]), _vm._v(" "), _c('p', {
    staticClass: "imager"
  }, [_c('img', {
    staticStyle: {
      "height": "70px"
    },
    attrs: {
      "alt": "image",
      "src": "images/pg27_3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "imagel"
  }, [_c('img', {
    staticStyle: {
      "height": "70px"
    },
    attrs: {
      "alt": "image",
      "src": "images/pg12_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image1",
    staticStyle: {
      "height": "7px"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "chap-title1",
    attrs: {
      "id": "sec5"
    }
  }, [_c('b', [_vm._v("Week 5: Discover Your"), _c('br'), _vm._v("Spiritual Gifts")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("“Each of you should use whatever gift you have received"), _c('br'), _vm._v("to serve others, as faithful stewards of God’s grace in its"), _c('br'), _vm._v("various forms.”")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote1"
  }, [_vm._v("—1 Peter 4:10")]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }, [_c('p', {
    staticClass: "noindents"
  }, [_vm._v("Recommended Reading:")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("The story of Mary Magdalene (John 20:11–18)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Ever felt like God has blessed you with a hidden superpower unique just to you? That’s your spiritual gift waiting to be discovered! God’s bestowed upon you special talents that aren’t just for show. They’re meant to shine, make a difference, and light up the world. This week, you’re on a mission to uncover that power.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Drawing inspiration from the Bible can often illuminate our paths. Mary Magdalene is an emblem of faith and devotion in the New Testament. From being one of the women who supported Jesus and his disciples to being the first witness of His resurrection, Mary’s spiritual journey is profound and transformative. Her gift was her steadfast devotion and clarity of vision.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Just as Mary stood firm in her faith and became a torchbearer of hope, you too have challenges to face and truths to proclaim. And just like Mary, you are equipped with gifts to make a difference. It wasn’t about her status or past; it was her undeniable faith and unique perspective that allowed Mary to shine. Like Mary Magdalene, your gifts can bring light to the darkest moments, no matter how hidden or overlooked.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Your True Self")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("It’s sometimes hard to hear your own voice while navigating high school, social media, and peer pressure. However, beyond those dramas, there’s a voice inside you, guiding you toward your true purpose. Mary Magdalene found her voice through the uncertainties and challenges of her life; you too can discover yours despite the noise of everyday life. When you connect with that voice and find the special gift God’s given you, life becomes an exciting journey of meaningful experiences.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Just as Mary had a unique spiritual gift of discernment and unwavering faith, you too have special gifts from God waiting to be recognized and harnessed. Reflect on your own connection with God. How might He reveal your spiritual gifts to you, even in unexpected moments? Dive deep into prayer, and ask God to illuminate those gifts within you, just as He did for Mary Magdalene. Your gifts have a purpose in God’s grand design, and, like Mary, you are called to use them for His glory.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Angela’s Awakening")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Just as Mary Magdalene was an unexpected disciple among the many followers of Jesus, Angela felt like another face in the crowd. Angela always felt like she was floating. Whether at school or church, she often found herself lost in the sea of faces, unsure of where she fit in. She was quiet, observant, and most of the time, felt painfully ordinary.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Angela stumbled upon an unexpected opportunity during the summer of her sixteenth year. A family friend mentioned an internship at the local community center. Having no concrete plans, Angela decided to take a chance on it. It wasn’t a glamorous gig. Initially, she did menial tasks: setting up meeting rooms, preparing refreshment stands, and handing out pamphlets. But as the weeks went by, something changed.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("It began with a children’s painting event. The assigned coordinator fell ill, and Angela was thrust into the organizer role. She hesitated, her self-doubt creeping in. But with gentle nudging from her mentor, Mrs. Collins, she took charge.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("It was like watching a flower bloom. Angela tapped into an unknown reservoir of confidence and clarity. She arranged the supplies, delegated responsibilities, handled a minor crisis when they ran out of blue paint, and encouraged the shy kids to express themselves. She sat late into the evenings, pouring over plans and details, ensuring everyone’s needs were met. Mrs. Collins often found her absorbed in her work and smiled, seeing the spark in Angela that had been dormant for so long.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("After the painting event’s success, Angela’s responsibilities at the center grew. From a simple art activity, she moved on to coordinating a local charity run, then a summer fair, and even a musical night. She began bringing teams together, coordinating events with the confidence of a star quarterback leading their team. The community, young and old, began to look forward to what Angela would come up with next. Her events were crafted with heart and care.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("One afternoon, as they sat together over tea, Mrs. Collins remarked, “Angela, everyone has a gift. Mary Magdalene had her devotion; you have your leadership. It just takes the right moment for us to realize it.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Angela looked up, her eyes shimmering with newfound realization. “Leadership,” she whispered. “That’s my gift.” She nodded. “It’s been there all along, just waiting for the right moment to shine.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The summer ended, but Angela’s journey had just begun. Back at church, the quiet girl in the background was now the vibrant young woman taking the initiative, leading groups, and sharing her newfound passion. She realized that, like her, others were also waiting to discover their spiritual gift.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Angela started a group in her church to help others find and embrace their unique gifts. Whether it was singing, teaching, counseling, or countless other roles, Angela made it her mission to help everyone realize their potential.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("It’s easy to feel lost in a crowd, to think you might not have a special skill or gift. But as Angela’s story shows, sometimes all it takes is one summer, one opportunity, to awaken the leader within. Everyone has a gift waiting to be discovered; it’s just a matter of finding the right moment to let it shine.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Daily Dose of Faith")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Just as Mary Magdalene embraced her role as a devoted follower, step up and embrace your spiritual gifts this week. Ready for a challenge? You could dive into a hobby you’ve always been curious about, volunteer in a new role at your church, or even just help a neighbor or friend in a unique way. Every step you take could lead you closer to your spiritual gift.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Living the Faith")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Mary’s unwavering devotion was her spiritual gift, guiding her as one of Jesus’s closest followers. The Gospel of John (John 20:11–18) gives us a touching account of Mary Magdalene’s encounter with the risen Jesus. After discovering the empty tomb, Mary was in deep grief. But in her most despairing moment, she was blessed with the spiritual gift of discernment. She recognized Jesus when others didn’t. Her deep connection and love for Christ allowed her to see Him, even when His appearance was changed.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Think of your spiritual gift as your personal brand of magic. Just like Angela, when you tap into it and serve others, you spread love and joy, and deepen your connection with God.")]), _vm._v(" "), _c('div', {
    staticClass: "black"
  }, [_c('p', {
    staticClass: "noindents1"
  }, [_c('b', [_vm._v("Journal Time!")])])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/star.jpg"
    }
  })]), _vm._v("If you were a superhero, what would be your power? Why?")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/star.jpg"
    }
  })]), _vm._v("Recall a time when you felt truly alive and happy. What were you doing?")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/star.jpg"
    }
  })]), _vm._v("Think about your closest friends. If you had to identify one spiritual gift for each of them, what would it be?")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Wrapping Up the Week")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("As you journey forward, remember the tales of Mary Magdalene and Angela. Discovering your spiritual gift isn’t just a one-time revelation; it’s an ongoing adventure. Your connection with God and understanding of your gifts will deepen as you evolve and grow. Keep searching, keep shining, and embrace the unique magic you bring to the world!")]), _vm._v(" "), _c('p', {
    staticClass: "imagel"
  }, [_c('img', {
    staticStyle: {
      "height": "70px"
    },
    attrs: {
      "alt": "image",
      "src": "images/pg10_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "imager"
  }, [_c('img', {
    staticStyle: {
      "height": "70px"
    },
    attrs: {
      "alt": "image",
      "src": "images/pg17_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image1",
    staticStyle: {
      "height": "7px"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "chap-title1",
    attrs: {
      "id": "sec6"
    }
  }, [_c('b', [_vm._v("Week 6: Overcome Fear"), _c('br'), _vm._v("and Anxiety")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("“So do not fear, for I am with you; do not be dismayed,"), _c('br'), _vm._v("for I am your God. I will strengthen you and help you;"), _c('br'), _vm._v("I will uphold you with my righteous right hand.”")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote1"
  }, [_vm._v("—Isaiah 41:10")]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }, [_c('p', {
    staticClass: "noindents"
  }, [_vm._v("Recommended Reading:")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("The story of Elijah’s victory over the prophets of Baal (1 Kings 18)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("From school assignments to friendship dramas, and even social media likes, there are a thousand things that might be causing you fear and anxiety. Just as Elijah stood firm against overwhelming odds, you can confidently face your challenges. Here’s some good news: you’re not alone in this, and with a sprinkle of faith, a dash of courage, and God’s enduring love, you can face and overcome these feelings.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In 1 Kings 18, the prophet Elijah stood alone against 450 prophets of Baal. Even though he was outnumbered, his faith in God never wavered. He challenged the prophets to a contest to prove whose God was real. Despite the odds and possible fears, Elijah triumphed as God answered his prayer by sending fire from the heavens. In your life too, your challenges, no matter how overwhelming, can be overcome when you place your faith in God. Like Elijah, even when you feel outnumbered by your fears, God is with you, ensuring you’re never truly alone.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Your True Self")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The world today is a whirlwind of demands. With the pressures of grades, social expectations, and digital personas, it’s easy to feel overwhelmed. But remember, your true worth isn’t measured by these transient standards but by God’s enduring love.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("A Dance Beyond Fear")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The chatter in the hallways was almost always about one thing: the upcoming prom. Jessica, a bubbly junior with a penchant for dreaming big, had doodled countless dresses in the margins of her notebooks. She imagined herself gliding across the dance floor, laughing with friends, capturing those cinematic moments of high school she had seen in countless movies.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("But as the days ticked closer to that magical evening, a cloud began to cast a shadow over Jessica’s excitement. Every time she thought about the prom, her heart raced—but not with joy. She imagined the whispers behind hands, the glances exchanged at her dress or shoes, and the unflattering photos that might circulate the next day. These fears turned her enthusiasm into anxiety.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("One evening, in the sanctuary of the church’s youth group meeting, Jessica mustered the courage to voice her fears. To her surprise, she wasn’t alone. Mark was worried about his height and being shorter than his date. Lila was anxious about dancing in public. Emily feared she’d stand out too much because she was opting for a pantsuit instead of a traditional dress. Their individual fears wove together a complex pattern of insecurities.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("And it was Rachel, the quietest of them all, who proposed an idea: “What if we turn our fears into strengths? Instead of focusing on what could go wrong, why don’t we support one another, reminding each other of our value in God’s eyes?”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("It was a simple plan, but it resonated with everyone. They created a pact. Leading up to the prom, they would meet for small pep talks, share scriptures that uplifted them, and pray together. They started a group chat where any member could share a worry and receive a wave of reassurance.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Jessica’s mom noticed the change in her daughter. Instead of fretting over which dress to buy, Jessica focused on finding something she genuinely loved, regardless of what was trendy. When Emily was unsure about her pantsuit, Jessica and the others rallied around her, telling her how confident and unique she looked.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("On prom night, the group met beforehand. They weren’t the most popular or glamorous group, but they radiated genuine happiness. They prayed together, asking God to guide them through the evening, to let them find joy in the simple moments, and to remember their worth wasn’t in the opinions of others but in His unwavering love.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The night wasn’t without its hitches. There were a few missteps on the dance floor and occasional awkward moments. But whenever one felt out of place, another would offer a reassuring smile or a comforting hand.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("As the night came to a close, Jessica and her friends stood outside, their shoes in hand, laughing about the night’s unexpected turns. The prom wasn’t perfect, but it was theirs, a night where they danced with their feet and with their souls, held aloft by faith and friendship.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In the end, it wasn’t just about a dance. It was a testament to the strength found in unity and the power of faith to transform fear into joy.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Daily Dose of Faith")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("When fear strikes, take a deep breath and draw strength from stories of faith like Elijah’s. Reflect on verses like Isaiah 41:10, reminding yourself, “With God, I am fearless.”")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Living the Faith")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Here’s another example to consider. Beatrice’s nervousness about public speaking is something many can relate to. When chosen to lead a class presentation, she tackled her fear head-on. By relying on her faith, she found strength she never knew she had.")]), _vm._v(" "), _c('div', {
    staticClass: "black"
  }, [_c('p', {
    staticClass: "noindents1"
  }, [_c('b', [_vm._v("Journal Time!")])])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/star.jpg"
    }
  })]), _vm._v("Think about a recent time you felt anxious or fearful. How did it feel physically and emotionally?")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/star.jpg"
    }
  })]), _vm._v("Remember a situation where you overcame a fear. What did you learn about yourself? How did God play a role in this?")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/star.jpg"
    }
  })]), _vm._v("Challenge: This week, reflect on a fear or anxiety you face often. Drawing inspiration from the stories shared, what steps can you take to address this fear? Write about your plan and intentions.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Wrapping Up the Week")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Life will always have its share of ups and downs. Fear and anxiety will come, but they don’t define you. Like Elijah, with his unyielding faith against overwhelming odds, with faith, a loving community, and God’s eternal presence, you can overcome anything. Embrace the journey, trust in God, and watch as your fears turn into tales of triumph. Life will always present challenges. But with faith, community, and God’s presence, you’re equipped to overcome them. As you move into the next week, what’s one step you’ll take to face fear with faith?")]), _vm._v(" "), _c('p', {
    staticClass: "imagel"
  }, [_c('img', {
    staticStyle: {
      "height": "70px"
    },
    attrs: {
      "alt": "image",
      "src": "images/pg10_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "imager"
  }, [_c('img', {
    staticStyle: {
      "height": "70px"
    },
    attrs: {
      "alt": "image",
      "src": "images/pg17_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image1",
    staticStyle: {
      "height": "7px"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "chap-title1",
    attrs: {
      "id": "sec7"
    }
  }, [_c('b', [_vm._v("Week 7: Embrace the Power"), _c('br'), _vm._v("of Forgiveness")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("“Be kind and compassionate to one another, forgiving"), _c('br'), _vm._v("each other, just as in Christ God forgave you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote1"
  }, [_vm._v("—Ephesians 4:32")]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }, [_c('p', {
    staticClass: "noindents"
  }, [_vm._v("Recommended Reading:")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("The story of Jesus being anointed by a sinful woman (Luke 7:36–50)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("We all have moments of regret, mistakes, or trespasses against others. Embracing forgiveness can often seem more challenging than holding onto resentment. However, as the story in Luke 7 demonstrates, when we come before God with genuine repentance, He grants us profound mercy. This week, tap into the boundless strength of forgiveness.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In Luke 7:36–50, during a dinner at a Pharisee’s house, a sinful woman entered with an alabaster jar of expensive perfume. She stood behind Jesus, weeping, and wet His feet with her tears. She wiped them with her hair, kissed them, and poured perfume on them. The Pharisee, named Simon, thought to himself that if Jesus were truly a prophet, He would know who this woman was and what kind of life she led. Jesus, knowing Simon’s thoughts, told him a parable about two debtors, emphasizing the greater love shown by the one who had been forgiven more. He then turned to the woman and said, “Your sins are forgiven.”This account highlights the depth of Jesus’s mercy and underscores the rejuvenating and redeeming power of forgiveness.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Your True Self")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In the ever-evolving world of drama—be it from school, friends, or even online—it’s so easy to get caught up in the hurt. However, when you reflect upon the sinful woman from Luke 7, who approached Jesus with genuine repentance and was graciously forgiven, you recognize the transformative power of mercy. Sometimes you feel wronged, and the idea of holding a grudge seems all too tempting. But remember this: harboring resentment can overshadow the radiant soul you truly are. The essence of your true self flourishes in love, understanding, and forgiveness.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("The Silent Months")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Marisol and Taylor were best friends; everyone at Covenant Middle School knew it. From shared secret handshakes to their love for vintage comics, they had been inseparable since the fifth grade. The duo faced every challenge and every awkward moment and celebrated every triumph together. So, when a misunderstood text threw a wrench into their seemingly unbreakable bond, the entire school was shocked.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("It began innocently enough. Marisol sent a text one evening, a simple one: “I saw him with someone else today.” It was meant to refer to their shared crush on a TV character they both adored, but the missing context made Taylor read it as real-life gossip about her recent ex-boyfriend. Words were taken out of context, leading to feelings of hurt and betrayal. Neither wanted to be the first to admit they might have overreacted. Fueled by hurt and pride, a slight misunderstanding became a chasm between them. Each day that passed without resolution added layers to their initial pain.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Weeks turned into months. They sat on opposite sides of the classroom and avoided eye contact in the hallways. Their mutual friends found themselves in the unfortunate position of having to pick sides. The absence of their usual laughter and inside jokes created an echoing void in the lives of everyone who knew them.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("One crisp Sunday morning, Marisol found herself in church, the weight of the strained friendship heavy on her mind. As the pastor began his sermon on forgiveness, she felt each word resonate within her, as if they were being spoken directly to her. The pastor spoke of the strength in letting go, the healing power of forgiveness, and the importance of mending broken ties. After the service, clutching the church bulletin as if it were a lifeline, Marisol made a decision. She took out her phone, her fingers hovering hesitantly over the keyboard, and typed out a message to Taylor: “Can we meet? I miss us.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The two met at their favorite spot, a quiet corner in the local park where they’d spent countless hours talking and dreaming. They sat far apart on the bench, separated by a heavy silence. But Marisol took a deep breath, bridged the gap, and began with a simple, “I’m sorry.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Taylor looked up, her eyes brimming with tears, “I’ve missed us too.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("They spoke for hours, dissecting the miscommunication, addressing the hurt, and reminiscing about the good times. There was laughter, there were tears, and most importantly, there was healing.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Marisol realized it wasn’t just about apologizing. It was about taking responsibility, understanding each other’s perspective, and valuing their bond over pride. Taylor recognized the importance of communication and how easy it was to let minor misunderstandings escalate.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Their reunion was not just a rekindling of old ties but a forging of new ones—stronger, more understanding, and deeply empathetic. They learned that friendships, like all relationships, require work, understanding, and, sometimes, a leap of faith. The rift that once seemed insurmountable became a testament to their bond, proving that any hurdle can be overcome with effort, understanding, and a touch of grace.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Daily Dose of Faith")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Consider starting your mornings with a simple affirmation: “Today, I choose love over anger, understanding over judgment, and forgiveness over resentment.” Remember the mercy Jesus showed in Luke 7. Hold onto this intention throughout your day, and when faced with challenges, let these words guide your heart.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Living the Faith")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Here’s another example to consider. Sophie always felt overshadowed by her younger sister, Marie-Christine, who seemed to excel in everything. One day, Sophie discovered Marie-Christine had borrowed her favorite dress without asking. In anger, Sophie tore up Marie-Christine’s art project. When she realized the depth of her actions, Sophie turned to prayer. She sought God’s guidance in mending their relationship. After a heartfelt conversation, the sisters forgave each other and began appreciating and supporting one another’s talents. Their reconciliation, inspired by divine teachings of forgiveness, showed the same kind of mercy that Jesus exemplified.")]), _vm._v(" "), _c('div', {
    staticClass: "black"
  }, [_c('p', {
    staticClass: "noindents1"
  }, [_c('b', [_vm._v("Journal Time!")])])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/star.jpg"
    }
  })]), _vm._v("We all have moments of struggle and understanding. Reflect on a time when you found it hard to forgive someone. How did that situation affect your emotions and overall well-being?")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/star.jpg"
    }
  })]), _vm._v("Imagine a scenario where you forgive that person. How does that make you feel? Lighter? Freer?")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/star.jpg"
    }
  })]), _vm._v("Think about a time when you sought forgiveness. How did others’ understanding (or lack thereof) influence your feelings and actions?")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/star.jpg"
    }
  })]), _vm._v("Write a letter (you don’t have to send it) to someone you want to forgive. Pour out your feelings and end with words of forgiveness.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Wrapping Up the Week")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Forgiveness is a profound act that can change lives, heal deep wounds, mend relationships, and usher in a newfound sense of peace. While forgiving might not change the past, it can change the future. Through God’s love and guidance, choose to be an exemplar of forgiveness and love in this world.")]), _vm._v(" "), _c('p', {
    staticClass: "imager"
  }, [_c('img', {
    staticStyle: {
      "height": "70px"
    },
    attrs: {
      "alt": "image",
      "src": "images/pg27_3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "imagel"
  }, [_c('img', {
    staticStyle: {
      "height": "70px"
    },
    attrs: {
      "alt": "image",
      "src": "images/pg12_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image1",
    staticStyle: {
      "height": "7px"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "chap-title1",
    attrs: {
      "id": "sec8"
    }
  }, [_c('b', [_vm._v("Week 8: Develop a"), _c('br'), _vm._v("Servant’s Heart")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("“For even the Son of Man did not come to be served,"), _c('br'), _vm._v("but to serve, and to give his life as a ransom for many.”")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote1"
  }, [_vm._v("—Mark 10:45")]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }, [_c('p', {
    staticClass: "noindents"
  }, [_vm._v("Recommended Reading:")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("The story of the woman at the well (John 4:1–26)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("There’s unparalleled beauty in extending a helping hand and opening your heart to those around you. This week, you’ll embark on a beautiful journey of cultivating a servant’s heart, enriching your life and those you touch. Just as Jesus reached out to the Samaritan woman in John 4:1–26, you are encouraged to extend your hand to those around you.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Jesus, tired from his journey, sat by a well in Samaria. A Samaritan woman came to draw water, and Jesus asked her for a drink. Surprised, as Jews didn’t associate with Samaritans, she questioned Him. Jesus spoke of the “living water,” which led to a deeper conversation about faith, worship, and truth. Jesus, through His act of service and genuine conversation, transformed her life. The woman, filled with newfound belief, became an ambassador of Christ’s love, sharing her experience with many.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Your True Self")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("With the whirlwind of school, social media, and trying to fit in, it’s easy to become self-focused. Yet, deep down, your soul craves genuine connections and actions that make a difference. Much like how Jesus took the time to connect deeply with the Samaritan woman, your true self thrives not in the number of likes you get but in the number of lives you touch.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("The Empty Chair")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The cafeteria was a buzz of excitement each day, filled with the familiar sounds of clinking trays, laughter, and the constant hum of chatter. In this dynamic atmosphere, there was always an anomaly: Lucy, who sat by herself at the end of a table, her tray containing little more than a sandwich and a bottle of water. Her eyes would often be fixed on a book or staring blankly at some distant point.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Fabienne, a lively junior with a wide group of friends, couldn’t help but notice. Day after day, while she laughed and chatted with her group, her eyes would drift toward Lucy. In such moments, she was reminded of the lessons from Jesus’s interaction at the well. Driven by a spirit akin to Christ’s own, a spirit of service and compassion, Fabienne decided to break her routine. She picked up her tray, took a deep breath, and headed toward Lucy’s table.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Is this seat taken?” Fabienne asked, pointing to the empty space next to Lucy.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Lucy, caught off guard, simply shook her head. “It’s open.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The first few minutes were filled with awkward silences and hesitant glances. Fabienne tried to keep the conversation light, asking about Lucy’s classes and her favorite subjects. Slowly, Lucy began to open up. “I moved here a couple of months ago,” she started, playing with the crust of her sandwich. “It’s been…different.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Fabienne nodded, urging her on. Over the next few weeks, the two met regularly during lunch. The conversations flowed more freely each day, and Lucy’s walls began to come down. “Today would’ve been my mom’s birthday,” she admitted one day, voice quivering slightly, her eyes more tired than usual. “She passed away last year.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Fabienne felt a pang in her chest, realizing the weight Lucy had been carrying alone. She reached across the table, covering Lucy’s hand with her own. No words were spoken, but the gesture spoke of understanding and compassion.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("As spring turned to summer, Lucy and Fabienne’s bond grew stronger. They found solace in shared stories, laughter, and comfortable silences. The school began to see a transformation in Lucy. From a reserved newcomer, she blossomed into an active community member, joining clubs and even helping Fabienne organize a support group for students dealing with grief.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("For Fabienne, the experience was transformative. Guided by a spirit of service reminiscent of Jesus’s approach, she had reached out and found a lifelong friend. The power of a simple act of kindness, she realized, could ripple through lives in ways she hadn’t imagined.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("On the last day of school, Fabienne and Lucy sat side by side, surrounded by a group of friends, laughter echoing around them. They shared glances, a silent acknowledgment of the journey they’d taken together.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In that bustling cafeteria, no chairs remained empty.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Daily Dose of Faith")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Make it a mission to perform at least one act of kindness daily. Remember the Samaritan woman and how a simple act of service from Jesus changed her life. It could be as simple as complimenting someone, assisting a teacher after class, or listening to a friend. These little acts nourish your soul and ripple out into the world in ways you might not even see.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Living the Faith")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Here’s another example to consider. Every Saturday, Ailani tutored younger students in her community who struggled academically. This act of service, inspired by the kindness Jesus displayed to the Samaritan woman, not only boosted their confidence but also filled Ailani with a sense of purpose.")]), _vm._v(" "), _c('div', {
    staticClass: "black"
  }, [_c('p', {
    staticClass: "noindents1"
  }, [_c('b', [_vm._v("Journal Time!")])])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/star.jpg"
    }
  })]), _vm._v("Think of someone in your life or community who could use help or companionship. What small act of service can you offer them?")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/star.jpg"
    }
  })]), _vm._v("Reflect on a time when someone served or helped you selflessly. How did that make you feel?")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/star.jpg"
    }
  })]), _vm._v("Jesus took the time to truly listen and converse with the Samaritan woman. Who in your life can you offer the gift of genuine listening?")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/star.jpg"
    }
  })]), _vm._v("Journal about a community or school project you’d like to start or join that embodies the spirit of serving others.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Wrapping Up the Week")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Drawing inspiration from Jesus’s kindness toward the Samaritan woman, you can see the value of service. In a world that often prioritizes self-promotion, choosing to serve becomes a revolutionary act. Through service, you uplift others and discover a deeper sense of purpose and connection. As you walk this path, remember, developing a servant’s heart isn’t about grand gestures but heartfelt moments of kindness and love. Be the change, one act of service at a time.")]), _vm._v(" "), _c('p', {
    staticClass: "imager"
  }, [_c('img', {
    staticStyle: {
      "height": "70px"
    },
    attrs: {
      "alt": "image",
      "src": "images/pg11_2.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e3574bc0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter01.vue
// module id = 78
// module chunks = 0